export const PERMS = {
    READ: 'report_driver_costs.read',
    EXPORT: 'report_driver_costs.export',
}
